import request from '../utils/request';

/**
 * 初始化治疗流程
 */
export const initTreatment = (code) => {
  return request.post(`/app-api/api/treatment/${code}`);
};

/**
 * 初始化治疗流程
 */
export const getTreatment = (params, code) => {
  return request.get(`/app-api/api/treatment/${code}/${params.id}/chat-history`);
};

/**
 * 获取用户治疗下一项内容
 */
export const getTreatmentNext = (data, code) => {
  return request.post(`/app-api/api/treatment/${code}/${data.id}/next`, { data });
};

/**
 * 自动跨过无分支引导确认，准备当天第一项未完成任务
 */
export const prepareDailyTask = (data, code) => {
  return request.post(`/app-api/api/treatment/${code}/${data.id}/prepare-daily-task`, { timeout: 30000 });
};

/**
 * 获取子任务历史
 */
export const getTreatmentDayitem = (params) => {
  return request.get(`/app-api/api/treatment/dayitem/${params.id}/chat-history`);
};


/**
 * 获取子任务下一项内容
*/
export const getTreatmentDayitemNext = (data) => {
  return request.post(`/app-api/api/treatment/dayitem/${data.id}/next`);
};

/**
 * 子任务提交数据
*/
export const dayitemStepsubmit = (data) => {
  return request.post(`/app-api/api/treatment/dayitem/${data.id}/stepsubmit`, { data });
};

/**
 * 子任务 发送消息
 */
export const sendMsg = (data) => {
  return request.post(`/app-api/api/treatment/dayitem/${data.id}/chat-history`, { data });
};

/**
 * 其他消息
 */
export const getFireevent = (data) => {
  return request.post(`/app-api/api/treatment/dayitem/${data.id}/fireevent/${data.event_name}`);
};

/**
 * video 完成
 */
export const videoComplete = (data) => {
  return request.post(`/app-api/api/treatment/dayitem/${data.id}/complete`);
};
